import 'uno.css'
import '@/utils/global'
import '@/utils/prototype'
import '@/assets/base.css'
import '@/assets/variables.css'

import 'remixicon/fonts/remixicon.css'
import 'element-plus/dist/index.css'

import { createApp } from 'vue'
import App from './App.vue'
import router from './routers'
import { store, key } from './store'
import i18n from "@/i18n"
import plugins from './plugins'
import ElementPlus from 'element-plus'
import Editor from '@/components/Editor/wrapper'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import Vue3TouchEvents from "vue3-touch-events";

  ; (window as any).store = store
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app
  .use(i18n)
  .use(store, key)
  .use(router)
  .use(Editor)
  .use(Vue3TouchEvents)
  .use(ElementPlus, { zIndex: 3000 })
  .use(plugins)
  .mount('#app')
